import { render, staticRenderFns } from "./price-category-table.vue?vue&type=template&id=e3e8ae78&scoped=true&"
import script from "./price-category-table.ts?vue&type=script&lang=ts&"
export * from "./price-category-table.ts?vue&type=script&lang=ts&"
import style0 from "./price-category-table.scss?vue&type=style&index=0&id=e3e8ae78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3e8ae78",
  null
  
)

export default component.exports